import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  InvoiceRequest,
  InvoiceResponse,
  SmsRequest,
  SmsResponse,
} from '../models/sms.model';

@Injectable({
  providedIn: 'root',
})
export class SmsService {

  constructor(private readonly http: HttpClient) {}

  getSmsStock(
    requestPayload: SmsRequest
  ): Observable<SmsResponse> {
    const url = 'sms/stock/available-stock';
    console.log(requestPayload);
    return this.http.post<SmsResponse>(url, requestPayload);
  }

  getInvoive(invoiceRequest:InvoiceRequest): Observable<InvoiceResponse> {
    const url = '/cross-border/invoices';
    console.log(invoiceRequest);
    return this.http.post<InvoiceResponse>(url, invoiceRequest);
  }
}
